import { Expose } from "class-transformer";

export class UpdateLocationDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  isOpen: boolean;

  @Expose()
  warehouseId: string;
}
